import { render, staticRenderFns } from "./UsuarioGeradorSenha.vue?vue&type=template&id=f9205ed8"
import script from "./UsuarioGeradorSenha.vue?vue&type=script&lang=js"
export * from "./UsuarioGeradorSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports